export default __webpack_public_path__ + "static/mongo-db-logo-dba53a275ed1cfa0a9342c096e054764.svg";